
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface RelatedServicesSectionProps {
  title: string;
  description: string;
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryButtonAction: () => void;
  secondaryButtonAction?: () => void;
  relatedServices?: Array<{
    name: string;
    path: string;
  }>;
}

export const RelatedServicesSection: React.FC<RelatedServicesSectionProps> = ({
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonAction,
  secondaryButtonAction,
  relatedServices = [],
}) => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold mb-6">{title}</h2>
          <p className="text-lg text-dental-muted mb-8">
            {description}
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button className="btn-primary flex items-center text-base group" onClick={primaryButtonAction}>
              {primaryButtonText}
              <ArrowRight size={18} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
            </Button>
            
            {secondaryButtonText && secondaryButtonAction && (
              <Button className="btn-secondary flex items-center text-base" onClick={secondaryButtonAction}>
                {secondaryButtonText}
              </Button>
            )}
          </div>
          
          {relatedServices.length > 0 && (
            <div className="mt-10">
              <p className="text-dental-muted mb-4">Interested in our other dental services in Nagpur?</p>
              <div className="flex flex-wrap justify-center gap-4">
                {relatedServices.map((service, index) => (
                  <Link 
                    key={index}
                    to={service.path} 
                    className="text-dental-highlight hover:text-dental-accent transition-colors"
                  >
                    {service.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
